"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constant = require("../Theme/constant");
var _default = {
  PropTypes: {
    accessible: _propTypes.default.bool,
    customButtonWidth: _propTypes.default.string,
    customProperties: _propTypes.default.object,
    data: _propTypes.default.array.isRequired,
    hoverColor: _propTypes.default.string,
    hoverBackgroundColor: _propTypes.default.string,
    theme: _propTypes.default.string,
    translation: _propTypes.default.object,
    vertical: _propTypes.default.bool,
    onClick: _propTypes.default.func,
    selectButtonBackgroundColor: _propTypes.default.string,
    selectedButtonBorderColor: _propTypes.default.string,
    value: _propTypes.default.string
  },
  DefaultProps: {
    accessible: true,
    customButtonWidth: "109.15px",
    color: 'neutral',
    hoverColor: 'neutral',
    theme: _constant.DEFAULT_THEME,
    vertical: false,
    onClick: function onClick() {}
  }
};
exports.default = _default;